import { createContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { storageKeys } from 'utilities/constants';
import AppStorage from 'utilities/storage.service';
import { FetchProvider } from './FetchContext';
import { UserProvider } from './UserContext';

const AuthContext = createContext();
const { Provider } = AuthContext;

function AuthProvider({ children }) {
  const history = useHistory();
  const token = AppStorage.getItem(storageKeys.APP_TOKEN);
  const refreshToken = AppStorage.getItem(storageKeys.REFRESH_TOKEN);

  const [authState, setAuthState] = useState({
    token,
    refreshToken,
    isAuthenticated: false,
    delayBeforeLoginSuccess: false,
  });

  function isAuthenticated() {
    return authState.isAuthenticated;
  }

  function logout() {
    AppStorage.deleteItem(storageKeys.APP_TOKEN);
    AppStorage.deleteItem(storageKeys.REFRESH_TOKEN);
    AppStorage.deleteItem(storageKeys.TOKEN_EXPIRY);
    AppStorage.deleteItem(storageKeys.PDF_JOBS);

    setAuthState({
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      delayBeforeLoginSuccess: false,
    });

    history.push('/');
  }

  function setTokens({ token, refreshToken }) {
    AppStorage.setItem(storageKeys.APP_TOKEN, token);
    AppStorage.setItem(storageKeys.REFRESH_TOKEN, refreshToken);

    setAuthState((x) => ({ ...x, token, refreshToken }));
  }

  function setIsAuthenticated(isAuthenticated) {
    setAuthState((x) => ({ ...x, isAuthenticated }));
  }

  function updateState(data = {}) {
    setAuthState((x) => ({ ...x, ...data }));
  }

  function clearAuthState() {
    AppStorage.deleteItem(storageKeys.PDF_JOBS);
    setAuthState({
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      delayBeforeLoginSuccess: false,
    });
  }

  return (
    <Provider
      value={{
        logout,
        authState,
        isAuthenticated,
        setTokens: (authData) => setTokens(authData),
        setIsAuthenticated,
        clearAuthState,
        updateState,
      }}
    >
      <FetchProvider>
        <UserProvider>{children}</UserProvider>
      </FetchProvider>
    </Provider>
  );
}

export { AuthProvider, AuthContext };
